/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { useSelectLang } from "@hooks/useLang";
import { copyallEducationalTraining, getEducationalTraining } from "@api/cms";
import { IMAGE_DOMAIN } from "@constants/api";
import EducationalTrainingModal from "@components/educationaltraining/EducationalTrainingModal";
import QuicklyCopySettings from "@components/shared/QuicklyCopySettings";
import { Card, Button, Icon } from "@mui/material";

export default function EducationalTrainingPage() {
  const { lang } = useSelectLang();
  const [educationalTraining, setEducationalTraining] = useState(null);

  const [selectedTraining, setSelectedTraining] = useState(null);

  const getData = async () => {
    const res = await getEducationalTraining(lang);
    setEducationalTraining(
      res
        ? res.map((r) => {
          return { ...r, imgUrl: `${IMAGE_DOMAIN}/${r.imagePath}` };
        })
        : []
    );

  };

  useEffect(() => {
    getData();
  }, [lang]);

  const addEducationalTraining = () => {
    setSelectedTraining({
      isAddNew: true,
      id: -1,
      title: "",
      image: null,
      imgUrl: "",
      language: lang,
      sort: 1,
    });
  };

  const handleCloseModal = async (reGetData) => {
    if (reGetData) await getData();
    setSelectedTraining(null);
  };

  const handleQuicklyCopySubmit = async (toLanguage) => {
    if (!lang || !toLanguage) {
      toast.error("請重新整理網頁後再嘗試");
    } else {
      const res = await copyallEducationalTraining({ fromLanguage: lang, toLanguage });
      if (res && typeof res === "object" && educationalTraining)
        if (res?.length === educationalTraining?.length)
          toast.success(`複製到 ${toLanguage} 成功`);
    }
  };

  return (
    <Card
      elevation={3}
      className="w-full overflow-auto"
      style={{ padding: "24px" }}
    >
      <EducationalTrainingPageWrap>
        <QuicklyCopySettings onSubmit={handleQuicklyCopySubmit} />
        教育訓練說明 - 250 x 250（長x寬）。<strong>圖片檔名不可重複</strong>
        <br />
        {`教學：點擊"新增教育訓練"按鈕，或者圖片來打開新增/修改視窗。-> 右上角"X"按鈕用於關閉。視窗內最下方的儲存/刪除按鈕提供該名稱所對應的功能。`}

        <Button
          variant="contained"
          color="secondary"
          onClick={addEducationalTraining}
          mt={10}
        >
          <Icon>add</Icon>&nbsp;
          新增教育訓練
        </Button>

        <div className="training-wrap">
          {educationalTraining &&
            educationalTraining.map((t) => (
              <div key={t.id} onClick={() => setSelectedTraining(t)}>
                <img src={t.imgUrl} alt={`${t.title}-${t.id}`} />
                <p className="training-title">{t.title}</p>
              </div>
            ))}
        </div>
        <EducationalTrainingModal
          show={selectedTraining !== null}
          item={selectedTraining}
          onClose={handleCloseModal}
        />
      </EducationalTrainingPageWrap>
    </Card>
  );
}

const EducationalTrainingPageWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  .training-wrap {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 20px;
    width: 100%;
    box-sizing: border-box;

    > div {
      margin: auto 0px;
      width: 200px;
      cursor: pointer;
      > img {
        width: 100%;
        height: auto;
      }
      .training-title {
        text-align: center;
        margin-top: 5px;
        font-size: 14px;
      }
    }
  }

  > button {
    margin: 10px 0px;
    width: 200px;
  }
`;